module.exports = __webpack_public_path__ + "static/media/parts.8.944c7a04.png";